export { default, getServerSidePageProps } from './ArticlePage';
